export default {
    header: 'Access for 30 days',
    description: 'The fastest way to find contractors',
    profit: '<p>{{percent}}%</p> SAVINGS',
};
